import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { makePostCall, clearAuthData } from "../../utils/helper";

// Self-service password change. Used both by the header "Change Password" modal
// (mandatory=false, cancellable) and by the forced first-login screen
// (mandatory=true, no cancel). The logged-in user is identified from the JWT on
// the backend, so no user identity is sent from here.
const ChangePassword = ({ onCancel, mandatory = false, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleChangePassword = async (values) => {
    const { newPassword, confirmPassword } = values;

    if (newPassword !== confirmPassword) {
      message.error("Passwords do not match!");
      return;
    }

    setLoading(true);
    try {
      const response = await makePostCall('/self-change-password', {
        new_password: newPassword
      });

      if (response.data?.success) {
        message.success("Password changed successfully! You will be logged out.");
        onSuccess?.();
        onCancel?.();
        // Logout and redirect to login so the user re-authenticates with the new
        // password and receives a fresh token (must_change_password now false).
        // Clears only auth state, not UI preferences (column configs, filters, etc.)
        clearAuthData();
        setTimeout(() => {
          localStorage.clear();
          window.location.replace("/login");
        }, 1500);
      } else {
        message.error(response.data?.message || "Failed to change password");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      message.error(error?.response?.data?.message || "Failed to change password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '30vh' }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleChangePassword}
        autoComplete="off"
        style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
      >
        <div style={{ paddingTop: '20px' }}>
          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[
              { required: true, message: "Please enter your new password" }
            ]}
            style={{ marginBottom: '24px' }}
          >
            <Input.Password placeholder="Enter new password" />
          </Form.Item>

          <Form.Item
            label="Confirm New Password"
            name="confirmPassword"
            rules={[
              { required: true, message: "Please confirm your new password" }
            ]}
            style={{ marginBottom: '20px' }}
          >
            <Input.Password placeholder="Confirm new password" />
          </Form.Item>
        </div>

        <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
          {!mandatory && (
            <Button onClick={onCancel} style={{ marginRight: 8 }}>
              Cancel
            </Button>
          )}
          <Button type="primary" htmlType="submit" loading={loading} block={mandatory}>
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ChangePassword;
